mutation UpdateChatSettingsEnableChat($input: ChatSettingsEnableChatInput!) {
    chatSettingsEnableChat(input: $input) {
        isChatEnabled
    }
}
